module.exports = __webpack_public_path__ + "img/function_message.56691fe0.png";